import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { DEFAULT_CURRENCY_CODE } from '@/utils/constants'
import { storage } from '../core'
import { CurrencyState } from './currency.types'

const initialState: CurrencyState = {
  code: DEFAULT_CURRENCY_CODE,
}

export const CURRENCY_STATE_NAME = 'currency'

export const currencySlice = createSlice({
  name: CURRENCY_STATE_NAME,
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<string>) => {
      state.code = action.payload
    },
  },
})

export const currencySliceConfig: PersistConfig<CurrencyState> = {
  storage,
  key: CURRENCY_STATE_NAME,
  whitelist: ['code'],
}

export const { setCurrency } = currencySlice.actions

export default currencySlice.reducer
